import { extendTheme } from "@chakra-ui/react";
import "@fontsource/poppins";

export const theme = extendTheme({
  styles: {
    global: {
      "html, body, button, input, textarea, select, a, div": {
        WebkitTapHighlightColor: "transparent",
      },
    },
  },
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Poppins, sans-serif",
    zilloutbusines: "zuume-rough, sans-serif",
  },
  colors: {
    subtle: "#9D9D9D",
    brand: "#8155FE",
    light: {
      bg: "#FFFFFF",
      text: "#0E1207",
      primary: "#8155FE",
      secondary: "#F0F0F0",
      card_bg: "#FFFFFF",
      card_border: "#E7E7E7",
      icon_color: "black",
    },
    dark: {
      bg: "#111111",
      text: "#FFFFFF",
      primary: "#8155FE",
      secondary: "#1E1E1E",
      card_bg: "#1E1E1E",
      card_border: "#3A3D43",
      icon_color: "white",
    },
  },
  components: {
    Link: {
      baseStyle: {
        textDecoration: "none",
        _hover: {
          textDecoration: "none",
        },
      },
    },
  },
});
